module.exports = __webpack_public_path__ + "static/img/xuqiuku1@2x.565421ff.png";